import axios from "axios";

const authService = axios.create({
  // baseURL: "http://192.168.0.103:5000/api/",
  baseURL: "https://www.lufihome.cz/api/",
  withCredentials: true,
  xsrfCookieName: "csrf_access_token",
});
export { authService };
